module.exports = __webpack_public_path__ + "static/media/16.96741cf5.mp3";